import brandPortalMyShopSettings from "@faire/web-api/routes/brand-portal/my-shop/settings";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var InternationalOrderSettings = function InternationalOrderSettings() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YKn+GK",
    defaultMessage: [{
      "type": 0,
      "value": "Sur Faire, vous pouvez choisir où vous souhaitez vendre vos produits. Vous pouvez limiter la vente dans certaines régions si vous y avez déjà des représentants commerciaux ou des distributeurs, ou si vos produits ne sont pas conformes aux lois sur la protection des consommateurs dans ces régions. Vous pouvez également activer les ventes aux clients de nouvelles régions quand vous le souhaitez."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "2++wCW",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez modifier ces paramètres à tout moment dans l'onglet "
    }, {
      "children": [{
        "type": 0,
        "value": "Plateforme"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " de votre portail, dans "
    }, {
      "children": [{
        "type": 0,
        "value": "Paramètres de la boutique"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": ". Ici, vous pouvez sélectionner les pays dans lesquels vous allez vendre vos produits, et définir des minimums de commande en fonction des régions d'expédition."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return shopSettingLinkFormatting(chunks);
      }
    }
  })));
};
var shopSettingLinkFormatting = function shopSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMyShopSettings(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};